module.exports = __webpack_public_path__ + "img/delivery.5a3f7f7c.svg";